import { render, staticRenderFns } from "./PurchasesOrderViewDetailsPurchasesOrderItemTableV1.vue?vue&type=template&id=72c65ddb"
import script from "./PurchasesOrderViewDetailsPurchasesOrderItemTableV1.vue?vue&type=script&lang=js"
export * from "./PurchasesOrderViewDetailsPurchasesOrderItemTableV1.vue?vue&type=script&lang=js"
import style0 from "./PurchasesOrderViewDetailsPurchasesOrderItemTableV1.vue?vue&type=style&index=0&id=72c65ddb&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports